import Yup, { globalValidations } from "@utils/yup";
import useTranslation from "next-translate/useTranslation";

export function InputTitle({ title, required = true }) {
  const { t } = useTranslation("submit-opportunities");

  return (
    <div className="!text-black !text-[12px] sm:!text-[16px]">
      {t(`${title}`)}{" "}
      {required && (
        <span
          style={{
            lineHeight: "0px",
            position: "relative",
            top: "7px ",
          }}
          className="text-[#f51717] !text-[20px] sm:!text-[25px]"
        >
          *
        </span>
      )}
    </div>
  );
}

export function InputDelTitle({ title }) {
  const { t } = useTranslation("delete-account");

  return (
    <div className="text-black !text-[12px] sm:!text-[16px]">
      {t(`delete_account_info.${title}`)}
      <span
        style={{
          fontWeight: "medium",
          lineHeight: "21px",
          position: "relative",
          top: "7px",
        }}
        className="text-[#f51717] !text-[12px] sm:!text-[16px]"
      >
        *
      </span>
    </div>
  );
}

// Schemas
const {
  requiredString_minmax,
  requiredString_nullable,
  requiredString,
  phoneValidator,
  emailValidator,
  filesValidator,
} = globalValidations;

// Provide investment opportunities Schema
export const InvestmentOpportunitiesSchema = Yup.object().shape({
  first_name: requiredString_minmax,
  last_name: requiredString_minmax,
  company_name: requiredString_minmax,
  phone_number: phoneValidator,
  email: emailValidator,
  you_are: requiredString,
  city: requiredString,
  district: requiredString,
  property_type: requiredString,
  property_size: requiredString,
  property_location: Yup.string().url("property_location").required(),
  copy_of_property_ownership: filesValidator,
  price_per_meter: Yup.string().nullable(),
  comment: requiredString.min(2),
});

// Real Estate Develop Schema
export const realEstateDevelopSchema = Yup.object().shape({
  company_name: requiredString_minmax,
  full_name: requiredString_minmax,
  website: Yup.string().typeError("nullable").nullable(),
  phone_number: phoneValidator,
  email: emailValidator,
  project_type: requiredString_nullable,
  city: requiredString,
  district: requiredString,
  total_project_area: requiredString,
  project_idea: requiredString,
  property_location: Yup.string().url("property_location"),
  copy_of_property_ownership: filesValidator,
  project_feasbility: filesValidator,
  project_documents: filesValidator,
  previous_project_documents: filesValidator,
  expected_project_length: requiredString,
  have_the_company_worked_with_CMA_funds: requiredString,
  previous_project_size: requiredString,
});

// PartnerShip Request Schema
export const partnershipRequestSchema = Yup.object().shape({
  company_name: requiredString_minmax,
  full_name: requiredString_minmax,
  phone_number: phoneValidator,
  email: emailValidator,
  message_subject: requiredString_nullable,
  message_content: requiredString.min(2),
});
